import React from "react";
import { useSelector } from "react-redux";

// Import Old Icons
import LogoIcon from "./LogoIcon";
import CompaniesIcon from "./CompaniesIcon";
import ScheduleIcon from "./AppointmentsIcon";
import WhiteboardIcon from "./WhiteBoardIcon";
import PatientVisitIcon from "./PatientVisit";
import LabIcon from "./LabIcon";
import PatientChatIcon from "./PatientChartIcon";
import ResultIcon from "./ResultIcon";
import SettingsIcon from "./SettingsIcon";
import EditIcon from "./EditIcon";
import RemoveIcon from "./RemoveIcon";
import UpdatetickIcon from "./UpdatetickIcon";
import CancelIcon from "./CancelIcon";
import Permission from "./PermissionIcon";
import ProfileIcon from "./ProfileIcon";
import ProfIcon from "./ProfIcon";
import GlobalIcon from "./GlobalIcon";
import AddPlusIcon from "./AddPlusIcon";
import LoginIcon from "./LoginIcon";
import OrgIcon from "./OrgIcon";
import ChangePasswordIcon from "./ChangePasswordIcon";
import LogoutIcon from "./LogoutIcon";
import SearchIcon from "./SearchIcon";
import FilterIcon from "./FilterIcon";
import BackIcon from "./BackIcon";
import AddIconDetailView from "./AddIconDetailView";
import EditIconDetailView from "./EditIconDetailView";
import DeleteIconDetailView from "./DeleteIconDetailView";
import ViewActivitiesIcon from "./ViewActivitiesIcon";
import PhysicalIcon from "./PhysicalIcon";
import ActivityChartIcon from "./ActivityChartIcon";
import WarningIcon from "./WarningIcon";
import PrintIcon from "./PrintIcon";
import ConsentView from "./ConsentView";
import CalenderPlusIcon from "./CalenderPlusIcon";
import UserGroupIcon from "./UserGroupIcon";
import AddPhysicalAndDrugIcon from "./AddPhysicalAndDrugIcon";
import DarkModeIcon from "./DarkModeIcon";
import DotRoundedIcon from "./DotRoundedIcon";
import CrossCloseIcon from "./CrossCloseIcon";
import LaborderIcon from "./LaborderIcon";
import NotificationIcon from "./NotificationIcon";
import CalenderIcon from "./CalenderIcon";
import StatusIcons from "./StatusIcons";
import QrCode from "./QrCode";
import TimeZoneIcon from "./TimeZoneIcon";
import CertificateIcon from "./CertificateIcon";
import CopyIcon from "./copyIcon";
import DashboardMessageIcon from "./dashboardmsg";
import ChatSquareTextFillIcon from "./ChatSquareTextFillIcon";
import EmailIcon from "./EmailIcon";
import SmsIcon from "./SmsIcon";
import PhoneIcon from "./PhoneIcon";
import BillingIcon from "./BillingIcon";
import RefreshIcon from "./RefreshIcon";
import CircleIcons from "./CircleIcons";
import ReportIcon from "./ReportsIcon";
import PlusIcon from "./PlusIcon";
import DashboardIcon from "./DashboardIcon";
import DashboardIcons from "./DashboardIcons";
import PatientVerifyIcon from "./PatientVerify";
import DownloadIcon from "./DownloadIcon";
import CloneIcon from "./CloneIcon";
import CloneIconNew from "./CloneIconNew";
// import LabOrderIcon from "./LabOrderIcon";
import ArrowIcon from "./ArrowIcon";
import FolderIcon from "./FolderIcon";
import UploadIcon from "./UploadIcon";
import FolderTreeIcon from "./FolderTreeIcon";
import ContractViewIcon from "./ContractIcon";
import DeleteIconForOption from "./DeleteIconForOption";
import ImagePatternIcon from "./ImagePatternIcon";
import DragIcon from "./DragIcon";
import SearchDarkBg from "./SearchDarkBg";
import OpenNewTab from "./OpenNewTab";
import IncidentIcon from "./IncidentIcon";
import FetchIcon from "./FetchIcon";
import ResolveError from "./ResolveError";
import NewStatusIcon from "./NewStatusIcon";
import CurrentDate from "./CurrentDate";
// Import New Icons
import {
  NewAddPatientIcon,
  NewAddPhysicalIcon,
  NewAddVisitIcon,
  NewAppointmentsIcon,
  NewBillingIcon,
  NewBillingTableIcon,
  NewChangePasswordIcon,
  NewChangeUIIcon,
  NewChartIcon,
  NewCompaniesIcon,
  NewDasboardIcon,
  NewDetailViewIcon,
  NewFollowUpIcon,
  NewIncidentIcon,
  NewLabsIcon,
  NewLogoutIcon,
  NewMeatBallIcon,
  NewNotificationIcon,
  NewPatientDetailsIcon,
  NewPatientsIcon,
  NewPhysicalDrugIcon,
  NewPrintIcon,
  NewProfileIcon,
  NewQrIcon,
  NewRemoveIcon,
  NewReportsIcon,
  NewResultIcon,
  NewStatusIcons,
  NewVaccinesIcon,
  NewVisitIcon,
  NewWhiteboard,
  NewTodayIcon,
  NoRecords,
  VisitHistoryIcon,
  HistoricalVisitListIcon,
  ChartIcon,
  ConsentFormIcon
} from "./NewIcons";
import CompletedIcon from "./CompletedIcon";
import QuestionAvailable from "./QuestionAvilable";
import QuestionSent from "./QuestionSent";
import QuestionCompleted from "./QuestionCompleted";
import BulkQuestionSend from "./BulkQuestionSend";
import BillIcon from "./BillIcon";
import VideoTutorialIcon from "./VideoTutorialIcon";
import NewCertificateIcon from "./NewCertificateIcon.js";
import newSettingsIcon from "./NewSettingsIcon.js";
import newEditIcon from "./newEditIcon.js";
import WorkStatusIcon from "./WorkStatusIcon";
import PlayIcon from "./PlayIcon";
import ActivePlayIcon from "./ActivePlayIcon";
import WorkCompIcon from "./WorkCompIcon.js";
import PhysicalsIcon from "./PhysicalsIcon.js";
import ScreeningsIcon from "./ScreeningsIcon.js";
import FormsIcon from "./FormsIcon.js";
import LaboratoryIcon from "./LaboratoryIcon.js";
import ReferralIcon from "./ ReferralIcon.js";
import ImagesIcon from "./ImagesIcon.js";
import VaccinesIcon from "./VaccinesIcon.js";
import NotesIcon from "./NotesIcon.js";
import DrugScreensIcon from "./DrugScreensIcon.js";
import AlertsIcon from "./AlertsIcon.js";
import ProviderPinVerifyIcon from "./ProviderPinVerifyIcon";
import ReloadSuggestionsIcon from "./ReloadSuggestionsIcon";
import AuditLogIcon from "./AuditLogIcon";
import VoiceIcon from "./VoiceIcon";
import VoiceDocInProgressIcon from "./VoiceDocInProgressIcon";
import VoiceDocCompleteIcon from "./VoiceDocCompleteIcon";

// -------------------- ICON MAPPINGS --------------------
const oldIcons = {
  Logo: LogoIcon,
  Company: CompaniesIcon,
  Schedule: ScheduleIcon,
  WhiteBoard: WhiteboardIcon,
  PatientVisit: PatientVisitIcon,
  Results: ResultIcon,
  Billing: BillingIcon,
  Labs: LabIcon,
  PatientChart: PatientChatIcon,
  Settings: SettingsIcon,
  newSettings:newSettingsIcon,
  Edit: EditIcon,
  Remove: RemoveIcon,
  Cancel: CancelIcon,
  Permission: Permission,
  ProfileIcon: ProfileIcon,
  GlobalIcon: GlobalIcon,
  AddPlus: AddPlusIcon,
  LoginIcon: LoginIcon,
  changepassword: ChangePasswordIcon,
  logout: LogoutIcon,
  Search: SearchIcon,
  Filter: FilterIcon,
  Back: BackIcon,
  Activities: ViewActivitiesIcon,
  Physical: PhysicalIcon,
  ActivityChart: ActivityChartIcon,
  Warning: WarningIcon,
  Print: PrintIcon,
  ConsentEdit: ConsentView,
  ConsentAdd: ConsentView,
  CalenderPlus: CalenderPlusIcon,
  Calender: CalenderIcon,
  UserGroup: UserGroupIcon,
  AddPhysical: AddPhysicalAndDrugIcon,
  DarkMode: DarkModeIcon,
  LightMode: DarkModeIcon,
  Dot: DotRoundedIcon,
  QrCode: QrCode,
  Download: DownloadIcon,
  Upload: UploadIcon,
  Close: CrossCloseIcon,
  DashboardIcon: DashboardIcon,
  "Labs Order": LaborderIcon,
  Copyicon: CopyIcon,
  ContractView: ContractViewIcon,
  clone: CloneIcon,
  cloneIconNew: CloneIconNew,
  // labOrderIcon: LabOrderIcon,
  DashboardMessage: DashboardMessageIcon,
  ChatSquareTextFill: ChatSquareTextFillIcon,
  AuditLog: AuditLogIcon,
  Email: EmailIcon,
  Sms: SmsIcon,
  Phone: PhoneIcon,
  TimeZone: TimeZoneIcon,
  Refresh: RefreshIcon,
  Verification: PatientVerifyIcon,
  Certificate: CertificateIcon,
  Reports: ReportIcon,
  Plus: PlusIcon,
  Notification: NotificationIcon,
  OpenNewTab: OpenNewTab,
  Folder: FolderIcon,
  FolderTree: FolderTreeIcon,
  Drag: DragIcon,
  DirectionalDrag: DragIcon,
  Fetch: FetchIcon,
  green: StatusIcons,
  greensmall: StatusIcons,
  grey: StatusIcons,
  red: StatusIcons,
  blue: StatusIcons,
  yellow: StatusIcons,
  patientdetails: StatusIcons,
  visitdetails: StatusIcons,
  companydetails: StatusIcons,
  labdetails: StatusIcons,
  Testdetails: StatusIcons,
  CircleIcons: CircleIcons,
  DashboardIcons: DashboardIcons,
  leftArrow: ArrowIcon,
  rightArrow: ArrowIcon,
  DeleteIconForOption: DeleteIconForOption,
  ImagePatternIcon: ImagePatternIcon,
  Incident: IncidentIcon,
  ResolveError: ResolveError,
  SearchDarkBg: SearchDarkBg,
  profile2:ProfIcon,
  NewChangeUIIcon:NewChangeUIIcon,
  Update:UpdatetickIcon,
  organization:OrgIcon,
  AddIconDetailView:AddIconDetailView,
  EditIconDetailView:EditIconDetailView,
  DeleteIconDetailView:DeleteIconDetailView,
  greencircle: CircleIcons,
  greycircle: CircleIcons,
  redcircle: CircleIcons,
  bluecircle: CircleIcons,
  yellowcircle: CircleIcons,
  DashboardInvoice: DashboardIcons,
  DashboardPhysical: DashboardIcons,
  DashboardDrug: DashboardIcons,
  DashboardCompliance: DashboardIcons,
  DashboardLab: DashboardIcons,
  DashboardComp: DashboardIcons,
  DashboardClaim: DashboardIcons,
  DashboardRestrictions: DashboardIcons,
  Completed:CompletedIcon,
  CurrentDate:CurrentDate,
  Question_Default:QuestionAvailable,
  Question_Available:QuestionAvailable,
  Question_Sent:QuestionSent,
  Question_Completed:QuestionCompleted,
  BulkQuestionSend:BulkQuestionSend,
  BillIcon:BillIcon,
  newTestResultsIcon:NewStatusIcons,
  newCompanyDetails:NewStatusIcons,
  WorkStatus: WorkStatusIcon,
  WorkComp: WorkCompIcon,
  Physicals:PhysicalsIcon,
  Screening:ScreeningsIcon,
  Notes:NotesIcon,
  Forms:FormsIcon,
  DrugScreens:DrugScreensIcon,
  Laboratory:LaboratoryIcon,
  Vaccines:VaccinesIcon,
  Referral:ReferralIcon,
  Images:ImagesIcon,
  Alerts:AlertsIcon,
  ProviderPinVerify: ProviderPinVerifyIcon,
  NewPatientDetailsIcon: NewPatientDetailsIcon,
  Voice: VoiceIcon,
  VoiceDocInProgress: VoiceDocInProgressIcon,
  VoiceDocComplete: VoiceDocCompleteIcon,
};

const newIcons = {
  ...oldIcons,
  cloneIconNew: CloneIconNew,
  // labOrderIcon: LabOrderIcon,
  Remove: NewRemoveIcon,
  WhiteBoard: NewWhiteboard,
  Results: NewResultIcon,
  Reports: NewReportsIcon,
  NewBillingIcon: NewBillingIcon,
  NewPatientsIcon: NewPatientsIcon,
  PatientVisit: NewVisitIcon,
  Labs: NewLabsIcon,
  Print:NewPrintIcon,
  "Labs Order":  NewLabsIcon,
  NewVaccinesIcon: NewVaccinesIcon,
  NewPhysicalDrugIcon: NewPhysicalDrugIcon,
  Incident: NewIncidentIcon,
  profile2: NewProfileIcon,
  changepassword: NewChangePasswordIcon,
  logout: NewLogoutIcon,
  Notification: NewNotificationIcon,
  NewQrIcon: NewQrIcon,
  NewTodayIcon: NewTodayIcon,
  NewAddVisitIcon: NewAddVisitIcon,
  NewAddPatientIcon: NewAddPatientIcon,
  Search: NewDetailViewIcon,
  ActivityChart: NewChartIcon,
  MeatBall: NewMeatBallIcon,
  green: NewStatusIcons,
  greensmall: NewStatusIcons,
  grey: NewStatusIcons,
  red: NewStatusIcons,
  blue: NewStatusIcons,
  yellow: NewStatusIcons,
  patientdetails: NewStatusIcons,
  visitdetails: NewStatusIcons,
  companydetails: NewStatusIcons,
  labdetails: NewStatusIcons,
  Testdetails: NewStatusIcons,
  BillingTable: NewBillingTableIcon,
  NewFollowUpIcon: NewFollowUpIcon,
  AddPhysical: NewAddPhysicalIcon,
  NoRecords: NoRecords,
  DashboardIcon:NewDasboardIcon,
  Schedule:NewAppointmentsIcon,
  NewChangeUIIcon:NewChangeUIIcon,
  notStarted: NewStatusIcon,
  passed: NewStatusIcon,
  pending: NewStatusIcon,
  failed: NewStatusIcon,
  pendingMRO: NewStatusIcon,
  pendingLab: NewStatusIcon,  
  Completed:CompletedIcon,
  Play:PlayIcon,
  ActivePlay:ActivePlayIcon,
  CurrentDate:CurrentDate,
  Question_Default:QuestionAvailable,
  Question_Available:QuestionAvailable,
  Question_Sent:QuestionSent,
  Question_Completed:QuestionCompleted,
  BulkQuestionSend:BulkQuestionSend,
  BillIcon:BillIcon,
  VideoIcon: VideoTutorialIcon,
  Certificate:NewCertificateIcon,
  newSettings:newSettingsIcon,
  newEdit:newEditIcon,
  newTestResultsIcon:NewStatusIcons,
  newCompanyDetails:NewStatusIcons,
  WorkStatus: WorkStatusIcon,
  NewPatientDetailsIcon: NewPatientDetailsIcon,
  ReloadSuggestions: ReloadSuggestionsIcon,
  VisitHistory: VisitHistoryIcon,
  HistoricalVisitListIcon: HistoricalVisitListIcon,
  ChartIcon: ChartIcon,
  ConsentFormIcon: ConsentFormIcon,
  Voice: VoiceIcon,
  VoiceDocInProgress: VoiceDocInProgressIcon,
  VoiceDocComplete: VoiceDocCompleteIcon,
};

// -------------------- ICON COMPONENT --------------------
const Icons = (props) => {
  const isNewUI = useSelector((state) => state.common.isNewUI);
  const { type } = props;

  const IconComponent = isNewUI ? newIcons[type] || oldIcons[type] : oldIcons[type];

  if (!IconComponent) return <></>;

  return <IconComponent {...props} />;
};

export default Icons;





// import React from "react";
// import LogoIcon from "./LogoIcon";
// import CompaniesIcon from "./CompaniesIcon";
// import ScheduleIcon from "./AppointmentsIcon";
// import WhiteboardIcon from "./WhiteBoardIcon";
// import PatientVisitIcon from "./PatientVisit";
// import LabIcon from "./LabIcon";
// import PatientChatIcon from "./PatientChartIcon";
// import ResultIcon from "./ResultIcon";
// import SettingsIcon from "./SettingsIcon";
// import EditIcon from "./EditIcon";
// import RemoveIcon from "./RemoveIcon";
// import UpdatetickIcon from "./UpdatetickIcon";
// import CancelIcon from "./CancelIcon";
// import Permission from "./PermissionIcon";
// import ProfileIcon from "./ProfileIcon";
// import ProfIcon from "./ProfIcon";
// import GlobalIcon from "./GlobalIcon";
// import AddPlusIcon from "./AddPlusIcon";
// import LoginIcon from "./LoginIcon";
// import OrgIcon from "./OrgIcon";
// import ChangePasswordIcon from "./ChangePasswordIcon";
// import LogoutIcon from "./LogoutIcon";
// import SearchIcon from "./SearchIcon";
// import FilterIcon from "./FilterIcon";
// import BackIcon from "./BackIcon";
// import AddIconDetailView from "./AddIconDetailView";
// import EditIconDetailView from "./EditIconDetailView";
// import DeleteIconDetailView from "./DeleteIconDetailView";
// import ViewActivitiesIcon from "./ViewActivitiesIcon";
// import PhysicalIcon from "./PhysicalIcon";
// import ActivityChartIcon from "./ActivityChartIcon";
// import WarningIcon from "./WarningIcon";
// import PrintIcon from "./PrintIcon";
// import ConsentView from "./ConsentView";
// import CalenderPlusIcon from "./CalenderPlusIcon";
// import UserGroupIcon from "./UserGroupIcon";
// import AddPhysicalAndDrugIcon from "./AddPhysicalAndDrugIcon";
// import DarkModeIcon from "./DarkModeIcon";
// import DotRoundedIcon from "./DotRoundedIcon";
// import CrossCloseIcon from "./CrossCloseIcon";
// import LaborderIcon from "./LaborderIcon";
// import NotificationIcon from "./NotificationIcon";
// import CalenderIcon from "./CalenderIcon";
// import StatusIcons from "./StatusIcons";
// import QrCode from "./QrCode";
// import TimeZoneIcon from "./TimeZoneIcon";
// import CertificateIcon from "./CertificateIcon";
// import CopyIcon from "./copyIcon";
// import DashboardMessageIcon from "./dashboardmsg";
// import BillingIcon from "./BillingIcon";
// import RefreshIcon from "./RefreshIcon";
// import CircleIcons from "./CircleIcons";
// import ReportIcon from "./ReportsIcon";
// import PlusIcon from "./PlusIcon";
// import DashboardIcon from "./DashboardIcon";
// import DashboardIcons from "./DashboardIcons";
// import PatientVerifyIcon from "./PatientVerify";
// import DownloadIcon from "./DownloadIcon";
// import CloneIcon from "./CloneIcon";
// import ArrowIcon from "./ArrowIcon";
// import FolderIcon from "./FolderIcon";
// import UploadIcon from "./UploadIcon";
// import FolderTreeIcon from "./FolderTreeIcon";
// import ContractViewIcon from "./ContractIcon";
// import DeleteIconForOption from "./DeleteIconForOption"
// import ImagePatternIcon from "./ImagePatternIcon";
// import DragIcon from "./DragIcon";
// import SearchDarkBg from "./SearchDarkBg";
// import OpenNewTab from "./OpenNewTab";
// import IncidentIcon from "./IncidentIcon";
// import FetchIcon from "./FetchIcon";
// import ResolveError from "./ResolveError";
// import {NewAddPatientIcon, NewAddPhysicalIcon, NewAddVisitIcon, NewAppointmentsIcon, NewBillingIcon, NewBillingTableIcon, NewChangePasswordIcon, NewChangeUIIcon, NewChartIcon, NewCompaniesIcon, NewDasboardIcon, NewDetailViewIcon, NewFollowUpIcon, NewIncidentIcon, NewLabsIcon, NewLogoutIcon, NewMeatBallIcon, NewNotificationIcon, NewPatientsIcon, NewPhysicalDrugIcon, NewProfileIcon, NewQrIcon, NewRemoveIcon, NewReportsIcon, NewResultIcon, NewStatusIcons, NewVaccinesIcon, NewVisitIcon, NewWhiteboard, NoRecords } from "./NewIcons";

// const Icons = (props) => {
//   const isNewUI = useSelector((state) => state.common.isNewUI);
//   const { type } = props;
//   switch (type) {
//     case "Logo":
//       return <LogoIcon {...props} />;
//     case "Company":
//       return <CompaniesIcon {...props} />;
//     case "organization":
//       return <OrgIcon {...props} />;
//     case "Schedule":
//       return <ScheduleIcon {...props} />;
//     case "WhiteBoard":
//       return <WhiteboardIcon {...props} />;
//     case "PatientVisit":
//       return <PatientVisitIcon {...props} />;
//     case "Results":
//       return <ResultIcon {...props} />;
//     case "Billing":
//         return <BillingIcon {...props} />;
//     case "Labs":
//       return <LabIcon {...props} />;
//     case "PatientChart":
//       return <PatientChatIcon {...props} />;
//     case "Settings":
//       return <SettingsIcon {...props} />;
//     case "Edit":
//       return <EditIcon {...props} />;
//     case "Cancel":
//       return <CancelIcon {...props} />;
//     case "Remove":
//       return <RemoveIcon {...props} />;
//       case 'ResolveError':
//         return <ResolveError {...props} />
//     case "Update":
//       return <UpdatetickIcon {...props} />;
//     case "Permission":
//       return <Permission {...props} />;
//     case "ProfileIcon":
//       return <ProfileIcon {...props} />;
//     case "profile2":
//       return <ProfIcon {...props} />;
//     case "GlobalIcon":
//       return <GlobalIcon {...props} />;
//     case "AddPlus":
//       return <AddPlusIcon {...props} />;
//     case "LoginIcon":
//       return <LoginIcon {...props} />;
//     case "changepassword":
//       return <ChangePasswordIcon {...props} />;
//     case "logout":
//       return <LogoutIcon {...props} />;
//     case "Search":
//       return <SearchIcon {...props} />;
//     case "SearchDarkBg":
//       return <SearchDarkBg {...props} />;
//     case "Filter":
//       return <FilterIcon {...props} />;
//     case "Back":
//       return <BackIcon {...props} />;
//     case "AddIconDetailView":
//       return <AddIconDetailView {...props} />;
//     case "EditIconDetailView":
//       return <EditIconDetailView {...props} />;
//     case "DeleteIconDetailView":
//       return <DeleteIconDetailView {...props} />;
//     case "Activities":
//       return <ViewActivitiesIcon {...props} />;
//     case 'Physical':
//       return <PhysicalIcon {...props} />
//     case 'ActivityChart':
//       return <ActivityChartIcon {...props} />
//     case 'Warning':
//       return <WarningIcon {...props} />
//     case 'Print':
//       return <PrintIcon {...props} />
//     case 'ConsentEdit':
//     case 'ConsentAdd':
//       return <ConsentView {...props} />;
//     case 'CalenderPlus':
//       return <CalenderPlusIcon />
//     case 'Calender':
//       return <CalenderIcon />
//     case 'UserGroup':
//       return <UserGroupIcon />
//     case 'AddPhysical':
//       return <AddPhysicalAndDrugIcon />
//     case 'DarkMode':
//     case 'LightMode':
//       return <DarkModeIcon {...props} />;
//     case 'Dot':
//       return <DotRoundedIcon {...props} />;
//     case 'QrCode':
//       return <QrCode {...props} />
//     case 'Download':
//       return <DownloadIcon {...props} />
//     case 'Upload':
//       return <UploadIcon {...props} />
//     case 'Close':
//       return <CrossCloseIcon {...props} />
//     case 'DashboardIcon':
//       return <DashboardIcon {...props} />
//     case 'Labs Order':
//       return <LaborderIcon {...props} />
//     case 'Copyicon':
//       return <CopyIcon {...props} />
//     case 'ContractView':
//       return <ContractViewIcon {...props} />
//     case 'clone':
//       return <CloneIcon {...props} />
//     case 'DashboardMessage':
//       return <DashboardMessageIcon {...props} />
//     case 'TimeZone':
//       return <TimeZoneIcon {...props} />
//     case 'Refresh':
//       return <RefreshIcon {...props} />
//     case 'Verification':
//       return <PatientVerifyIcon {...props} />
//     case 'Certificate':
//       return <CertificateIcon {...props} />
//     case 'Reports':
//       return <ReportIcon {...props} />
//     case 'Plus':
//       return <PlusIcon {...props} />
//     case 'Notification':
//       return <NotificationIcon {...props} />
//     case 'OpenNewTab':
//       return <OpenNewTab {...props} />
//     case 'Folder':
//       return <FolderIcon {...props} />
//     case 'FolderTree':
//       return <FolderTreeIcon {...props} />
//     case 'Drag':
//     case 'DirectionalDrag':
//     return <DragIcon {...props}/>
//     case 'Fetch':
//       return <FetchIcon {...props} />
//     case 'green':
//     case 'grey':
//     case 'red':
//     case 'blue':
//     case 'yellow':
//     case 'patientdetails':
//     case 'visitdetails':
//     case 'companydetails':
//     case 'labdetails':
//     case 'Testdetails':
//       return <StatusIcons {...props} />
//     case 'greencircle':
//     case 'greycircle':
//     case 'redcircle':
//     case 'bluecircle':
//     case 'yellowcircle':
//       return <CircleIcons {...props} />
//     case 'DashboardInvoice':
//     case 'DashboardPhysical':
//     case 'DashboardDrug':
//     case 'DashboardCompliance':
//     case 'DashboardLab':
//     case 'DashboardComp':
//     case 'DashboardClaim':
//     case 'DashboardRestrictions':
//       return <DashboardIcons {...props} />
//     case 'leftArrow':
//     case 'rightArrow':
//       return <ArrowIcon {...props} />
//     case 'DeleteIconForOption':
//       return <DeleteIconForOption {...props} />
//     case 'ImagePatternIcon':
//       return<ImagePatternIcon/>
//     case 'Incident':
//       return<IncidentIcon/>  
//     case 'NewAppointmentsIcon':
//       return <NewAppointmentsIcon {...props} />
//     case 'NewResultIcon':
//       return <NewResultIcon {...props} />
//     case 'NewCompaniesIcon':
//       return <NewCompaniesIcon {...props} />
//     case 'NewDasboardIcon':
//       return <NewDasboardIcon {...props} />
//     case 'NewReportsIcon':
//       return <NewReportsIcon {...props} />
//     case 'NewBillingIcon':
//       return <NewBillingIcon {...props} />   
//      case 'NewPatientsIcon':
//       return <NewPatientsIcon {...props} />
//     case 'NewVisitIcon':
//       return <NewVisitIcon {...props} />
//     case 'NewWhiteboard':
//       return <NewWhiteboard {...props} /> 
//     case 'NewLabsIcon':
//       return <NewLabsIcon {...props} />
//     case 'NewVaccinesIcon':
//       return <NewVaccinesIcon {...props} />
//     case 'NewPhysicalDrugIcon':
//       return <NewPhysicalDrugIcon {...props} />
//     case 'NewIncidentIcon':
//       return <NewIncidentIcon {...props} />    
//     case 'NewProfileIcon':
//       return <NewProfileIcon {...props} />
//     case 'NewChangePasswordIcon':
//       return <NewChangePasswordIcon {...props} />
//     case 'NewChangeUIIcon':
//       return <NewChangeUIIcon {...props} />
//     case 'NewLogoutIcon':
//       return <NewLogoutIcon {...props} />
//     case 'NewNotificationIcon':
//       return <NewNotificationIcon {...props} />   
//     case 'NewQrIcon':   
//       return <NewQrIcon {...props} />   
//     case 'NewAddVisitIcon':    
//       return <NewAddVisitIcon {...props} />
//     case 'NewAddPatientIcon':
//       return <NewAddPatientIcon {...props} />
//     case 'NewDetailViewIcon':
//       return <NewDetailViewIcon {...props} />
//     case 'NewChartIcon':
//       return <NewChartIcon {...props} />
//     case 'NewRemoveIcon':
//       return <NewRemoveIcon {...props} />
//     case 'NewMeatBallIcon':
//       return <NewMeatBallIcon {...props} />
//     case 'Newgreen':
//     case 'Newred':
//     case 'Newblue':
//     case 'Newyellow':
//       return <NewStatusIcons {...props} />
//       case 'NewBillingTableIcon':
//         return <NewBillingTableIcon {...props} />
//     case "NewFollowUpIcon":
//     return <NewFollowUpIcon {...props}/>
//     case "NewAddPhysicalIcon" :
//         return <NewAddPhysicalIcon {...props} />
//     case "NoRecords" :
//         return <NoRecords {...props} />
//     default:
    
//       return <></>;
//   }
// };

// export default Icons;
